import React from 'react'
import { useTranslation } from 'react-i18next'
import { Switch, Route } from 'react-router-dom'
import dayjs from 'dayjs'

import TopPanel from '../top-panel/TopPanelContainer'
import RootRoute from '../routes/RootRoute'
import CabinetRoute from '../routes/CabinetRoute'
import StreamerCardRoute from '../routes/StreamerCardRoute'
import StreamCardRoute from '../routes/StreamCardRoute'

import StreamPopup from '../streamer-popup/StreamerPopup'

import './App.css'

// The root component of the application
const App = () => {
  const { t, i18n } = useTranslation()
  dayjs.locale(i18n.language.substring(0, 2)) // setting global date locale to the current lang

  return (
    <>
      {/* Switch for routes w/o TopPanel */}
      <Switch>
        <Route exact path='/webcam' component={StreamPopup} />

        <Route render={() => (
          <div className='App'>
            <TopPanel />

            {/* Navigation switch, for routes with TopPanel */}
            <Switch>
              <Route exact path='/' component={RootRoute} />

              <Route exact path='/cabinet' component={CabinetRoute} />

              <Route exact path='/streamer-card/:id' component={StreamerCardRoute} />

              <Route exact path='/stream-card/:idStreamer/:idStream' component={StreamCardRoute} />

              {/* The default route, in case non of the above matched */}
              <Route render={() => (<h2>404. Not found.</h2>)} />
            </Switch>

            <hr />
            <footer>
              <p>&copy; 2018 - Worldon
                <a style={{ marginLeft: '15px' }} href="mailto:support@worldon.com">
                  {t('TopBar:contact tech support')}
                </a>
              </p>
            </footer>
          </div>
        )} />
      </Switch>

    </>
  )
}

export default App
